function contact() {
  $('.gform_body input[type=radio]').each(function() {
    if ($(this).prop('checked')) {
      $(this).addClass('active');
    }
  })

  $('.gform_body input[type=radio]').click(function() {
    $(this).closest('.gfield_radio').find('input[type=radio]').removeClass('active');
    $(this).addClass('active');
  });

  $(document).on('gform_confirmation_loaded', function() {
    $('.content p').hide();
    $('.form-bottom-notice').hide();
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top - 190
    }, 1000);
  });
}

export { contact };
